import {
    GetRequest
} from '@/api/base';

export default null;

export function getIsShowCommCalls(params: object, callback: Function) {
    GetRequest('v3/web/community/communityCalls/getIsShowCommCalls', params, callback);
}
